import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import { Hero } from '@/components/sections/Hero';
import { MainContent } from '@/components/sections/MainContent';
import { Footer } from '@/components/layout/Footer';
import { resolveImagePath } from '@/utils/imageMap';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
      </Helmet>
      
      <div className="min-h-screen bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${resolveImagePath('/wp-content/uploads/2017/04/bg-minuteman.jpg')})` }}>
        <Header />
        <Hero />
        <MainContent />
        <Footer />
      </div>
    </>
  );
}